import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { N0FlightStatusRequest } from '@models/requests/flight-status-request.model';
import {
  RouteScheduleDateResponse,
  RouteScheduleRequest,
} from '@models/requests/route-schedule-request.model';
import { N0FlightStatusResult } from '@models/responses/flight-status.model';
import { Observable } from 'rxjs';
import { Booking } from 'src/app/models/booking.models';
import { TripSellRequest } from 'src/app/models/requests/trip-sell-request.model';
import { ApiResponse } from 'src/app/models/responses/api-response.model';
import { EnvironmentService } from '../environment-service/environment.service';
import { SellBundleRequest } from "@models/requests/sell-bundle-request.model";

@Injectable({
  providedIn: 'root',
})
export class TripService {
  private static readonly CONTROLLER_ROOT = 'v1/trip';
  private static readonly FLIGHT_INFO_ROOT = 'v1/flightinfo';

  constructor(private httpClient: HttpClient) {}

  sellTrip(
    request: TripSellRequest,
    clearBooking = false,
  ): Observable<ApiResponse<Booking>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TripService.CONTROLLER_ROOT}/sell?clear=${clearBooking}`;
    return this.httpClient.post<ApiResponse<Booking>>(endpoint, request);
  }

  sellBundle(
    request: SellBundleRequest,
  ): Observable<ApiResponse<Booking>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TripService.CONTROLLER_ROOT}/sellbundle`;
    return this.httpClient.post<ApiResponse<Booking>>(endpoint, request);
  }

  getBundlePrice(code: string): Observable<ApiResponse<number>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TripService.CONTROLLER_ROOT}/bundleprice/${code}`;
    return this.httpClient.get<ApiResponse<number>>(endpoint);
  }

  getSchedule(
    request: RouteScheduleRequest,
  ): Observable<ApiResponse<RouteScheduleDateResponse[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TripService.CONTROLLER_ROOT}/schedule?Origin=${request.origin}&Destination=${request.destination}&BeginDate=${request.beginDate}&EndDate=${request.endDate}`;
    return this.httpClient.get<ApiResponse<RouteScheduleDateResponse[]>>(
      endpoint,
    );
  }

  searchFlightStatuses(
    request: N0FlightStatusRequest,
  ): Observable<ApiResponse<N0FlightStatusResult[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TripService.FLIGHT_INFO_ROOT}/status`;
    return this.httpClient.post<ApiResponse<N0FlightStatusResult[]>>(
      endpoint,
      request,
    );
  }
}
